export const authRoles = {
  dashboard: ['Administrator','Applicant','Officer','Consul','Attache','CA','CO','PA'], // Only Super Admin has access
  datasetup: ['PA'], // Only Super Admin has access
  // usercreate: ['Super Admin', 'Admin','Developer'], // Only SA & Admin has access
  // userview: ['Super Admin', 'ADMIN', 'Developer'], // Only SA & Admin & Editor has access
  // incidentview: ['Super Admin', 'ADMIN', 'Developer'], // Everyone has access
  // electionChange:['Super Admin', 'ADMIN', 'Developer']
}

// Check out app/views/dashboard/DashboardRoutes.js
// Only SA & Admin has dashboard access

// const dashboardRoutes = [
//   {
//     path: "/dashboard/analytics",
//     component: Analytics,
//     auth: authRoles.admin <----------------
//   }
// ];